import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

export const SliderWrapper = styled.div`
  height: 4.375rem;
  display: none;
  position: relative;

  @media (min-width: ${breakpoints.md}) {
    display: block;
  }
`;

const commonImgStyles = css`
  max-width: 4.375rem !important;
  max-height: 4.375rem !important;
  vertical-align: bottom;
  width: auto !important;
  height: auto !important;
  overflow: hidden;
`;

const newCommonImgStyles = css`
  width: 8.75rem !important;
  height: 8.75rem !important;
  object-fit: cover;
  overflow: hidden;
  border-radius: 0.25rem;
`;

export const Img = styled.img<{ newDesign: boolean; isSelected: boolean }>`
  cursor: pointer;
  display: inline;
  ${({ newDesign }) => (newDesign ? newCommonImgStyles : commonImgStyles)}
  ${({ isSelected, newDesign }) =>
    !isSelected &&
    newDesign &&
    css`
      opacity: 0.5;
    `}
`;

export const Div = styled.div<{ newDesign: boolean }>`
  min-width: 4.375rem;
  line-height: 1rem;
  position: relative;
  margin-bottom: 0.3125rem;

  cursor: pointer;
  text-align: center;

  ${({ newDesign }) =>
    newDesign
      ? css`
          mix-blend-mode: multiply;
        `
      : css`
          padding: 0 0.3125rem;
          background-color: ${theme.color.background.primary};
        `}
`;

export const TopMostDiv = styled.div<{ newDesign: boolean }>`
  ${({ newDesign }) =>
    newDesign &&
    css`
      position: relative;
      border-radius: 0.25rem;
      background-color: ${theme.color.background.disabled};
    `}
`;

export const Border = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  border: 2px solid ${theme.color.border.selected};
  border-radius: 0.25rem;
`;

export const VideoIcon = styled.div`
  opacity: 0.8;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
